export enum Language {
  AR = 'ar',
  EN = 'en',
}
